export const OFFER_CREATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferCreated";
export const OFFER_PREAPPROVAL_SUBMITTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferPreApprovalSubmitted";

export const TASKS_COMMAND_EXECUTION_ERROR = "PublishedLanguage.Events.TasksCommandExecutionError";
export const REPORTS_COMMAND_EXECUTION_ERROR = "PublishedLanguage.Events.ReportsCommandExecutionError";
export const COMMAND_VALIDATION_ERROR = "PublishedLanguage.Events.CommandValidationError";
export const COMMAND_EXECUTION_ERROR = "PublishedLanguage.Events.CommandExecutionError";
export const COMMAND_EXECUTION_WARNING = "PublishedLanguage.Events.CommandExecutionWarning";
export const COMMAND_EXECUTION_INFORMATION = "PublishedLanguage.Events.CommandExecutionInformation";

export const OFFER_NEXT_STATES_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferNextStatesListComputed";
export const OFFER_STATE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferStateUpdated";
export const OFFER_CLONE_CREATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferCloneCreated";
export const OFFER_COPIED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.LeasingOfferCopied";
export const OFFER_WARNINGS_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferWarningsChanged";
export const DOCUMENT_WORKFLOW_ERROR_DISMISSED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentWorkflowErrorDismissed";
export const OFFER_FINANCIAL_PRODUCT_RULE_READONLY_FIELDS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferFinancialProductRuleOutputDataInvalidated";

export const OFFERS_EXPORTED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.ExportOffersExecuted";
export const OFFER_REPORTS_EXECUTED = "Charisma.Leasing.PublishedLanguage.Events.Report.DocumentReportsExecuted";
export const DOCUMENT_REPORT_GENERATED = "Charisma.Leasing.PublishedLanguage.Events.Report.DocumentReportGenerated";

export const FOLDERS_EXPORTED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.ExportFoldersExecuted";
export const FOLDER_LIST_COMPUTED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.FolderListComputed";
export const FOLDER_LIST_COMPUTE_FINISHED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.ComputeFolderListFinished";
export const OFFER_FOLDER_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferFolderUpdated";
//Settings
export const CACHE_RESET = "Charisma.Leasing.PublishedLanguage.Events.Settings.CacheReset";
export const LANGUAGE_PUBLISHED = "Tasks.PublishedLanguage.Events.Definition.LanguagePublished";

export const OUT_OF_OFFICE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.User.OutOfOffice.OutOfOfficeUpdated";

export const OFFER_DECISION_SELECTED_CONDITIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionConditionsUpdated";
export const OFFER_DECISION_FINANCED_ASSET_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionFinancedAssetInvalidated";
export const OFFER_DECISION_SUMMARY_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionSummaryInvalidated";
export const OFFER_DECISION_APPROVAL_LEVELS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionApprovalLevelsInvalidated";
export const OFFER_DECISION_SUBSEQUENT_CONDITIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionSubsequentConditionsUpdated";
export const OFFER_DECISION_SUBSEQUENT_CONDITION_OVERDUE =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Decision.OfferDecisionSubsequentConditionsOverdue";
export const USER_RIGHTS_CHANGED = "Charisma.Leasing.PublishedLanguage.Events.ErpUser.UserRightsChanged";

//ORCHESTRATOR
export const OFFER_ORCHESTRATOR_FOLDER_GENERATED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.FolderGenerated";
export const OFFER_ORCHESTRATOR_ENABLED = "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.LeasingOfferEnabled";
export const OFFER_ORCHESTRATOR_VERIFICATION_LAUCHED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.OfferVerificationLaunched";
export const OFFER_ORCHESTRATOR_VERIFICATION_FINISHED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.OfferVerificationFinished";
export const OFFER_ORCHESTRATOR_VERIFICATION_FAILED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.OfferVerificationFailed";
export const OFFER_ORCHESTRATOR_SCORING_GENERATED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.OfferScoringGenerated";
export const FOLDER_ORCHESTRATOR_SCORING_GENERATED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.FolderScoringGenerated";
export const OFFER_ORCHESTRATOR_COMPETENCE_ORDER_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.CompetenceOrderExecuted";
export const OFFER_ORCHESTRATOR_AUTOMATIC_STATE_TRANSITION_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.AutomaticStateTransitionExecuted";
export const OFFER_ORCHESTRATOR_GENERATE_CONTRACT_FINISHED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.GenerateContractFinished";
export const OFFER_ORCHESTRATOR_CURRENT_OFFER_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.CurrentOfferInvalidated";
export const OFFER_ORCHESTRATOR_FACILITY_FOLDER_GENERATED = "Charisma.Leasing.PublishedLanguage.Events.Orchestrator.FacilityFolderGenerated";

//NOTIFICATIONS
export const NOTIFICATION_MARKED_AS_READ = "Notifier.PublishedLanguage.IntegrationEvents.NotificationMarkedAsRead";
export const NOTIFICATION_SENT = "Notifier.PublishedLanguage.IntegrationEvents.NotificationSent";
export const NOTIFICATION_DISMISSED = "Notifier.PublishedLanguage.IntegrationEvents.NotificationDismissed";
export const ALL_NOTIFICATIONS_MARKED_AS_READ =
  "Notifier.PublishedLanguage.IntegrationEvents.AllNotificationsMarkedAsRead";
export const ALL_NOTIFICATIONS_DISMISSED = "Notifier.PublishedLanguage.IntegrationEvents.DismissAllNotifications";

